module.exports = __webpack_public_path__ + "img/logo1.d3369ef2.png";